import { useState } from 'react';
import { ContentHeader, Table } from '@app/shared';
import { ClosureReasonForm } from './ClosureReasonsForm';
import { useClosureReasons } from '@app/sdk';
import { ComponentErrorBoundary } from '@app/utilities';
import { ColDef } from 'ag-grid-community';
import { MasterDetailLayout } from '../../components/MasterDetailLayout';
import { Segment } from 'semantic-ui-react';

export function ClosureReasons() {
  const [selectedReason, setSelectedReason] = useState(undefined as any);
  const { data: closureReasons } = useClosureReasons();

  const columnDefs: ColDef[] = [
    { field: 'id', headerName: 'Id' },
    { field: 'reason', headerName: 'Reason' },
    { field: 'description', headerName: 'Description' },
    { field: 'type', headerName: 'Type' },
  ];

  const master = (
    <>
      <ContentHeader>
        Closure Reasons
        <button className={'ui button'} onClick={() => setSelectedReason(undefined)} disabled>
          Add Closure Reason
        </button>
      </ContentHeader>
      <div style={{ height: 'calc(100% - 100px)' }}>
        <Table items={closureReasons} onSelectItem={setSelectedReason} columnDefs={columnDefs} />
      </div>
    </>
  );

  const detail = (
    <Segment>
      <ContentHeader>{selectedReason ? 'Update Closure Reason' : 'Add Closure Reason'}</ContentHeader>
      <ClosureReasonForm key={JSON.stringify(selectedReason)} closureReason={selectedReason} />
    </Segment>
  );

  return (
    <ComponentErrorBoundary>
      <MasterDetailLayout master={master} detail={detail} />
    </ComponentErrorBoundary>
  );
}
